import { Popover } from "antd";

interface PlanReviewOllieOriginalProps {
	/** Name of the field, for example "Observation". The popover reads "Ollie’s original Observation". */
	fieldLabel: string;
	/** The value Ollie wrote, already formatted as text. */
	originalValue?: string | null;
	/** Extra class for the link, so each screen can give it its own color. */
	className?: string;
}

/**
 * "View Ollie’s original" link. Shown next to a field that the AHJ reviewer changed; the popover
 * shows the value that Ollie wrote. A click on it does not reach the card or row behind it.
 */
const PlanReviewOllieOriginal = ({ fieldLabel, originalValue, className }: PlanReviewOllieOriginalProps) => (
	<span className="proo" onClick={event => event.stopPropagation()}>
		<Popover
			trigger="click"
			placement="bottom"
			arrow={false}
			overlayClassName="proo-popover"
			content={
				<div className="proo-content">
					<span className="proo-label">Ollie’s original {fieldLabel}</span>
					<p className="proo-value">{originalValue || "None"}</p>
				</div>
			}
		>
			<button type="button" className={`proo-link${className ? ` ${className}` : ""}`}>
				View Ollie’s original
			</button>
		</Popover>
	</span>
);

export default PlanReviewOllieOriginal;
